export const syncCalendar = {
  title: "Sincroniza tus calendarios",
  description:
    "!Tu alojamiento esta disponible en varias webs? Sincronizar tus calendarios te ayudará a ver tus reservas y disponibilidad en todos los canales a la vez. Puedes importar y exportar calendarios en formato ICal y mantener tu listado de check-in programados actualizados.",
  accommodation: "Alojamiento",
  sync: "Sincronizar",
  addCalendar: "Agregar nuevo calendario",
  confirmSync: {
    message: "¿Quieres actualizar los calendarios?",
  },
  syncSuccess: {
    message: "Calendarios sincronizados correctamente",
    title: "Éxito al sincronizar",
  },
  calendarName: "Nombre del calendario",
  modal: {
    header: "Agregar calendario",
    nameLabel: "Ingresa el nombre del calendario",
    linkLabel: "Copia y pega el enlace de tu calendario aquí",
    linkPlaceholder: "Enlace Ical",
    cancel: "Cancelar",
    save: "Guardar y Sincronizar",
  },
  saveSuccess: {
    message: "Éxito",
    title: "Calendario guardado con éxito",
  },
  errors: {
    validationTitle: "Validación fallida",
    saveErrorTitle: "Error guardando el calendario",
    unexpected: "Ocurrió un error inesperado.",
  },
  list: {
    updated: "Actualizado",
    status: "Estado",
    synced: "Sincronizado",
    delete: "Eliminar",
    empty: "No hay calendarios sincronizados",
  },
  deleteConfirm: {
    title: "¿Quieres eliminar el calendario?",
    content:
      'Al eliminar el calendario, también se eliminarán las reservas sincronizadas en el menú "Check-in Programados (reservas)"',
  },
  deleteSuccess: {
    message: "Calendario eliminado correctamente",
    title: "Eliminado",
  },
  deleteError: {
    message: "Error al eliminar el calendario",
    title: "Error",
  },
};
